import Link from 'next/link'
import { useTranslations } from 'next-intl'

import Text from '~/components/atoms/Text/Text'

import styles from './EmptyGrowthMessage.module.css'

export default function EmptyGrowthMessage() {
  const tCommon = useTranslations('common')
  return (
    <Link href="mailto:enquiries@myartbroker.com" className={styles.link}>
      <Text>
        Insufficient historical data for 5 Year AAGR.{' '}
        <u>{tCommon('contactUs')}</u> for more info.
      </Text>
    </Link>
  )
}
